/**
 * Whether Bids Analysis shows the S&P average index price.
 *
 * S&P credentials are per user (Anton 2026-09-29, decision 1): the average shows only when S&P
 * accepted the VIEWING user's own login — `userSettings.platts_subscriber` from `GET /user/setting/`,
 * which every role reads. The airline's stored login no longer turns it on for everyone.
 */
export function averagePriceEnabled(
    userSettings: { platts_subscriber?: boolean } | null | undefined
): boolean {
    return userSettings?.platts_subscriber === true;
}
